export default __webpack_public_path__ + "static/press-awards-wausau-88330390679bec7cb47c898fbd9c0427.png";